// extracted by mini-css-extract-plugin
module.exports = {"footerNumberOne":"NumberOne_footer-number-one__bouA6"};